<section class="cooperative-housing-contract-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (dataContext) {
    @if (dataContext.isNew) {
      <ng-container *ngTemplateOutlet="newContractLayout"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="existingContractLayout"></ng-container>
    }
  }

  <ng-template #existingContractLayout>
    <astral-form [form]="form" [columns]="4" (formSubmit)="onSubmit()">
      <section class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
          <astral-input
            class="astral-grid-span-2"
            label="COOPERATIVE_HOUSING.OBJECT"
            [value]="dataContext.rentalObject"
            [readonly]="true"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.READ_ONLY_FIELDS'"
          ></astral-input>
          <astral-input
            label="LEASE_AGREEMENT.STATUS"
            [value]="dataContext.statusCaption | translate"
            [readonly]="true"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.STATUS'"
          ></astral-input>
        </astral-layout-group>
      </section>
    </astral-form>

    <div class="astral-content-width astral-accordion-stack">
      <astral-accordion class="astral-grid-full" [header]="'COOPERATIVE_HOUSING.OBJECT'">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <astral-input label="RENTAL_OBJECT.OBJECT" [value]="dataContext.rentalObject" [readonly]="true"></astral-input>
          <astral-input
            label="RENTAL_OBJECT_TYPE_FORM.NAME_LABEL"
            [value]="dataContext.rentalObjectTypeName"
            [readonly]="true"
          ></astral-input>
          <astral-input label="RENTAL_OBJECT_FORM.SURFACE_LABEL" [value]="dataContext.rentalObjectSurface" [readonly]="true"></astral-input>
          <div class="astral-link-action astral-form-adjacent-action">
            <astral-button
              variant="link-button"
              type="button"
              labelKey="COMMON.OPEN_RENTAL_OBJECT_COOPERATIVE_HOUSING"
              (click)="onOpenRentalObjectClicked()"
            ></astral-button>
          </div>
          <astral-input label="COMMON.COMPANY" [value]="dataContext.companyName" [readonly]="true"></astral-input>
          <astral-input label="COMMON.PROPERTY" [value]="dataContext.propertyName" [readonly]="true"></astral-input>
          @if (dataContext.buildingName) {
            <astral-input label="COMMON.BUILDING" [value]="dataContext.buildingName" [readonly]="true"></astral-input>
          }
          <astral-input [control]="form.controls['atticStorageNumber']"></astral-input>
          <astral-input [control]="form.controls['basementStorageNumber']"></astral-input>
          <astral-input [control]="form.controls['otherStorageNumber']"></astral-input>
          <astral-input [control]="form.controls['parkingIncludedInRent']"></astral-input>
        </astral-layout-group>
      </astral-accordion>

      <astral-accordion class="astral-grid-full" [header]="'COOPERATIVE_HOUSING.OWNER'" (stateChanged)="allowSectionInit('leaseAgreements')" [allowWidthExpansion]="true">
        @if (isSectionAllowed('leaseAgreements')) {
          <div class="astral-stack-l">
            <div class="astral-content-width astral-stack-l">
              @for (ownerForm of $any(owners.controls); track ownerForm; let i = $index) {
                <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
                  <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                    <div class="astral-grid-span-2">
                      <app-autocomplete-remote
                        [service]="contactFilterService"
                        [control]="ownerForm.controls['contactId']"
                        (itemSelectedNewId)="onTenantSelected($event, ownerForm)"
                      ></app-autocomplete-remote>
                    </div>
                    <astral-input [control]="ownerForm.controls['share']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                    <astral-date-picker [control]="ownerForm.controls['memberFrom']"></astral-date-picker>
                    <astral-date-picker [control]="ownerForm.controls['approvalDate']"></astral-date-picker>
                    @if (owners.length > 1) {
                      <div class="astral-delete-action astral-form-adjacent-action">
                        <astral-button
                          variant="secondary"
                          size="small"
                          type="button"
                          icon="trash"
                          labelKey="DELETE_BTN"
                          (click)="deleteOwner(i)"
                        ></astral-button>
                      </div>
                    }
                    @if (ownerForm.controls['email'].value) {
                      <astral-input class="astral-grid-span-2" [control]="ownerForm.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
                    }
                    @if (ownerForm.controls['phone'].value) {
                      <astral-input [control]="ownerForm.controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
                    }
                    <app-money-box [control]="ownerForm.controls['amortizationAmount']"></app-money-box>
                    <div class="astral-link-action astral-form-adjacent-action">
                      <astral-button
                        variant="link-button"
                        type="button"
                        labelKey="COMMON.OPEN_CONTACT"
                        (click)="onOpenOwnerClicked(ownerForm.controls['contactId'].value)"
                      ></astral-button>
                    </div>
                  </astral-layout-group>
                </section>
              }

              <div>
                <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_BTN" (click)="addOwner()"></astral-button>
              </div>
            </div>

            @if (dataContext.hasOtherLeaseAgreements) {
              <div class="astral-stack-m">
                <app-information-block [text]="'LEASE_AGREEMENT.HELP_TEXT.OTHER_LEASE_AGREEMENTS'"></app-information-block>
                <app-list-view
                  [columnDefinition]="otherLeaseAgreementColumnDefinition"
                  [itemsSource]="dataContext.otherLeaseAgreements"
                  [preferencesKey]="'cooperative-housing-contract.other-lease-agreements'"
                  (rowClick)="onOtherLeaseAgreementClicked($event)"
                ></app-list-view>
              </div>
            }
          </div>
        }
      </astral-accordion>

      @if (form) {
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HEADER'">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-date-picker
              [control]="form.controls['accessDate']"
              [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.ACCESS_DATE'"
            ></astral-date-picker>
            <astral-date-picker
              [control]="form.controls['agreementDate']"
              [model]="dataContext.agreementDate"
              [label]="'LEASE_AGREEMENT.AGREEMENT_DATE'"
              [isRequired]="true"
              [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.AGREEMENT_DATE'"
            ></astral-date-picker>
            @if (displayLastBillingDate) {
              <astral-date-picker [control]="form.controls['lastBillingDate']"></astral-date-picker>
            }
          </astral-layout-group>
        </astral-accordion>
      }

      <astral-accordion class="astral-grid-full" [header]="'COOPERATIVE_HOUSING.FEE'" (stateChanged)="allowSectionInit('leaseRows')">
        @if (isSectionAllowed('leaseRows')) {
          <div class="astral-stack-l">
            <app-lease-rows
              [form]="form"
              [leaseStartDate]="fromDate"
              [currency]="dataContext.currencyCode"
              [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
              [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
              [currentPeriodText]="dataContext.currentPeriodText"
              [rentalObjectSize]="rentalObjectSurface"
              [leaseAgreementInvoicePeriod]="dataContext.invoicePeriod"
              [leaseAgreementCategory]="'CooperativeHousing'"
              [cultureName]="dataContext.cultureName"
              [itemsSource]="leaseAgreementRows"
              [entityId]="dataContext.id"
              [companyId]="dataContext.company"
              [contractService]="dataService"
              (itemSourceChange)="onItemSourceChange($event)"
              (leaseRowsChange)="onLeaseRowsChange($event)"
            ></app-lease-rows>

            <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
              <app-money-box [control]="form.controls['originalContractualRent']"></app-money-box>
              <astral-select [control]="form.controls['rentPayment']" [itemsSource]="rentPayments"></astral-select>
              @if (!isRentPaymentCustomOrTotal) {
                <astral-select [control]="form.controls['householdElectricityPayment']" [itemsSource]="householdElectricityPayments"></astral-select>
                <astral-select [control]="form.controls['heatingPayment']" [itemsSource]="heatingPayments"></astral-select>
                <astral-select [control]="form.controls['coldWaterPayment']" [itemsSource]="coldWaterPayments"></astral-select>
                <astral-select [control]="form.controls['hotWaterPayment']" [itemsSource]="hotWaterPayments"></astral-select>
              }
              @if (isRentPaymentCustom) {
                <astral-textarea
                  class="astral-grid-full"
                  [control]="form.controls['rentPaymentTerms']"
                  [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENT_PAYMENT_TERMS'"
                ></astral-textarea>
              }
            </astral-layout-group>
          </div>
        }
      </astral-accordion>

      <ng-container *ngTemplateOutlet="invoicingSection"></ng-container>

      <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.TERMS'">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <astral-textarea class="astral-grid-full" [control]="form.controls['specialTerms']"></astral-textarea>
        </astral-layout-group>
      </astral-accordion>

      <astral-accordion class="astral-grid-full" [header]="'REPRESENTATIVE.BLOCK_NAME'" [counter]="dataContext.representatives.length">
        <div class="astral-layout-item">
          <app-representative-manager [dataContext]="dataContext" [isBrf]="true" [form]="form"></app-representative-manager>
        </div>
      </astral-accordion>

      <astral-accordion class="astral-grid-full" [header]="'COOPERATIVE_HOUSING.MORTGAGE_PRESCRIPTION'">
        <div class="astral-stack-l">
          @for (group of $any(brfMortgagePrescriptions.controls); track group; let i = $index) {
            <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
              <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                <astral-input [control]="group.controls['mortgageOrder']" [type]="'number'" [inputMode]="'numeric'"></astral-input>
                <astral-input [control]="group.controls['mortgageNumber']"></astral-input>
                <div>
                  <app-autocomplete-remote
                    [service]="creditInstituteService"
                    [control]="group.controls['creditInstituteId']"
                    [defaultSearch]="'*'"
                  ></app-autocomplete-remote>
                </div>
                <astral-date-picker [control]="group.controls['fromDate']"></astral-date-picker>
                <astral-date-picker [control]="group.controls['toDate']"></astral-date-picker>
                <app-money-box [control]="group.controls['amount']"></app-money-box>
                <div class="astral-delete-action astral-form-adjacent-action">
                  <astral-button
                    variant="secondary"
                    size="small"
                    type="button"
                    icon="trash"
                    labelKey="DELETE_BTN"
                    (click)="removeBrfMortgagePrescription(i)"
                  ></astral-button>
                </div>
              </astral-layout-group>
            </section>
          }
          <div>
            <astral-button
              variant="primary"
              size="small"
              type="button"
              icon="plus"
              labelKey="COOPERATIVE_HOUSING.ADD_MORTGAGE_PRESCRIPTION"
              (click)="addBrfMortgagePrescription()"
            ></astral-button>
          </div>
        </div>
      </astral-accordion>

      @if (showBrfTransfer) {
        <astral-accordion class="astral-grid-full" [header]="'COOPERATIVE_HOUSING.TRANSFER'">
          <div class="astral-layout-item">
            <app-transfer-list [rentalObjectId]="dataContext.rentalObjectId"></app-transfer-list>
          </div>
        </astral-accordion>
      }

      <astral-accordion
        class="astral-grid-full"
        [header]="'SUBLEASE_REQUEST.LIST_HEADER'"
        (stateChanged)="allowSectionInit('subLease')"
        [indicator]="activeSubleaseRequestsCount > 0"
      >
        @if (isSectionAllowed('subLease')) {
          <div class="astral-layout-item">
            <app-sublease-requests [form]="form" [leaseStartDate]="fromDate" [itemsSource]="subleaseRequests"></app-sublease-requests>
          </div>
        }
      </astral-accordion>

      <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.SECURITY_HEADER'" [indicator]="hasSecurity">
        <div class="astral-layout-item">
          <app-contract-security [form]="form" [dataContext]="dataContext"></app-contract-security>
        </div>
      </astral-accordion>

      <astral-accordion class="astral-grid-full" [header]="'COMMON.NOTE'" [indicator]="!!dataContext.note">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <astral-textarea class="astral-grid-full" [control]="form.controls['note']"></astral-textarea>
        </astral-layout-group>
      </astral-accordion>

      @if (dataContext.fastighetsagarnaDokumentActive) {
        <astral-accordion
          class="astral-grid-full"
          [header]="'FASTIGHETSAGARNA_DOKUMENT.FASTIGHETSAGARNA_DOKUMENT'"
          [helpText]="'FASTIGHETSAGARNA_DOKUMENT.HELP_TEXT.ACCORDION_HEADER'"
          (stateChanged)="allowSectionInit('fastDok')"
        >
          @if (isSectionAllowed('fastDok')) {
            <div class="astral-layout-item">
              <app-form-cases-fastighetsagarna-dokument
                [form]="form"
                [itemsSource]="dataContext.leaseAgreementForms"
                [leaseAgreementId]="dataContext.id"
                [leaseAgreementCategory]="0"
              ></app-form-cases-fastighetsagarna-dokument>
            </div>
          }
        </astral-accordion>
      }

      @if (form) {
        <astral-accordion class="astral-grid-full" [header]="'CONSUMPTION.CONSUMPTION'" (stateChanged)="allowSectionInit('imdConsumption')" [allowWidthExpansion]="true">
          <div class="astral-layout-item">
            <app-information-block [text]="'CONSUMPTION.CONSUMPTION_LEASE_AGREEMENT_DESCRIPTION'"></app-information-block>
          </div>
          @if (isSectionAllowed('imdConsumption')) {
            <div class="astral-layout-item wrap-rows">
              <app-list-view
                [columnDefinition]="imdConsumptionColumnDefinition"
                [itemsSource]="imdConsumption"
                [preferencesKey]="'cooperative-housing-contract.imd-consumption'"
              ></app-list-view>
            </div>
          }
        </astral-accordion>
      }

      <astral-accordion
        class="astral-grid-full"
        [header]="'FAULT_NOTIFICATION.EDIT_HEADER'"
        [helpText]="'FAULT_NOTIFICATION.HELP_TEXT.LEASE_AGREEMENT_INFORMATION'"
        (stateChanged)="allowSectionInit('faultNotification')"
       [allowWidthExpansion]="true">
        @if (isSectionAllowed('faultNotification')) {
          <div class="astral-layout-item wrap-rows">
            <app-list-view
              [columnDefinition]="faultNotificationColumnDefinition"
              [itemsSource]="dataContext.faultNotifications"
              [preferencesKey]="'cooperative-housing-contract.fault-notifications'"
              (rowClick)="onFaultNotificationRowClicked($event)"
            ></app-list-view>
          </div>
        }
      </astral-accordion>
      <astral-accordion class="astral-grid-full" [header]="'DOCUMENT.DOCUMENTS'" [counter]="cooperativeHousingDocumentCount" [fragment]="documentsFragment">
        <div class="astral-stack-l">
          <div>
            <astral-button
              variant="primary"
              type="button"
              icon="plus"
              labelKey="LEASE_AGREEMENT.COMMAND.LINK_DOCUMENT"
              (click)="linkDocument()"
            ></astral-button>
          </div>
          <app-lease-agreement-document-manager
            [leaseAgreementId]="$safeNavigationMigration(dataContext?.id)"
            (countChange)="cooperativeHousingDocumentCount = $event"
          ></app-lease-agreement-document-manager>
        </div>
      </astral-accordion>
    </div>
  </ng-template>

  <ng-template #newContractLayout>
    <div class="astral-content-width astral-stack-l">
      <app-information-block [text]="'COOPERATIVE_HOUSING.INFORMATION_TEXT.NEW_COOPERATIVE_HOUSING_AGREEMENT'"></app-information-block>

      <form class="astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <section class="astral-section-surface astral-stack-m">
          <h4>{{ 'COOPERATIVE_HOUSING.OBJECT' | translate }}</h4>
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <app-vacant-period-cooperative-housing-autocomplete
              [control]="form.controls['rentalObject']"
            ></app-vacant-period-cooperative-housing-autocomplete>
            <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
            <astral-input [control]="form.controls['atticStorageNumber']"></astral-input>
            <astral-input [control]="form.controls['basementStorageNumber']"></astral-input>
            <astral-input [control]="form.controls['otherStorageNumber']"></astral-input>
            <astral-input [control]="form.controls['parkingIncludedInRent']"></astral-input>
          </astral-layout-group>
        </section>

        <section class="astral-section-surface astral-stack-m">
          <h4>{{ 'COOPERATIVE_HOUSING.OWNER' | translate }}</h4>
          @for (ownerForm of $any(owners.controls); track ownerForm; let i = $index) {
            <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
              <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                <div class="astral-grid-span-2">
                  <app-autocomplete-remote
                    [service]="contactFilterService"
                    [control]="ownerForm.controls['contactId']"
                    (itemSelected)="onTenantSelected($event, ownerForm)"
                  ></app-autocomplete-remote>
                </div>
                <astral-input [control]="ownerForm.controls['share']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                <astral-date-picker [control]="ownerForm.controls['memberFrom']"></astral-date-picker>
                <astral-date-picker [control]="ownerForm.controls['approvalDate']"></astral-date-picker>
                @if (owners.length > 1) {
                  <div class="astral-delete-action astral-form-adjacent-action">
                    <astral-button
                      variant="secondary"
                      size="small"
                      type="button"
                      icon="trash"
                      labelKey="DELETE_BTN"
                      (click)="deleteOwner(i)"
                    ></astral-button>
                  </div>
                }
                @if (ownerForm.controls['email'].value) {
                  <astral-input class="astral-grid-span-2" [control]="ownerForm.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
                }
                @if (ownerForm.controls['phone'].value) {
                  <astral-input class="astral-grid-span-2" [control]="ownerForm.controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
                }
              </astral-layout-group>
            </section>
          }
          <div>
            <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_BTN" (click)="addOwner()"></astral-button>
          </div>
        </section>

        <section class="astral-section-surface astral-stack-m">
          <h4>{{ 'COOPERATIVE_HOUSING.AGREEMENT_DATES_HEADER' | translate }}</h4>
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-date-picker
              [control]="form.controls['accessDate']"
              [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.ACCESS_DATE'"
            ></astral-date-picker>
            <astral-date-picker
              [control]="form.controls['agreementDate']"
              [model]="dataContext.agreementDate"
              [label]="'LEASE_AGREEMENT.AGREEMENT_DATE'"
              [isRequired]="true"
              [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.AGREEMENT_DATE'"
            ></astral-date-picker>
          </astral-layout-group>
        </section>

        <section class="astral-section-surface astral-stack-l">
          <h4>{{ 'COOPERATIVE_HOUSING.INVOICING_HEADER' | translate }}</h4>
          <app-lease-rows
            [form]="form"
            [leaseStartDate]="fromDate"
            [currency]="dataContext.currencyCode"
            [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
            [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
            [currentPeriodText]="dataContext.currentPeriodText"
            [leaseAgreementCategory]="'CooperativeHousing'"
            [rentalObjectSize]="rentalObjectSurface"
            [leaseAgreementInvoicePeriod]="dataContext.invoicePeriod"
            [header]="false"
            [cultureName]="dataContext.cultureName"
            [itemsSource]="leaseAgreementRows"
            [entityId]="dataContext.id"
            [contractService]="dataService"
            [companyId]="dataContext.company"
            (itemSourceChange)="onItemSourceChange($event)"
            (leaseRowsChange)="onLeaseRowsChange($event)"
          ></app-lease-rows>

          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <app-money-box [control]="form.controls['originalContractualRent']"></app-money-box>
            <astral-select [control]="form.controls['rentPayment']" [itemsSource]="rentPayments"></astral-select>
            @if (!isRentPaymentCustomOrTotal) {
              <astral-select [control]="form.controls['householdElectricityPayment']" [itemsSource]="householdElectricityPayments"></astral-select>
              <astral-select [control]="form.controls['heatingPayment']" [itemsSource]="heatingPayments"></astral-select>
              <astral-select [control]="form.controls['coldWaterPayment']" [itemsSource]="coldWaterPayments"></astral-select>
              <astral-select [control]="form.controls['hotWaterPayment']" [itemsSource]="hotWaterPayments"></astral-select>
            }
            @if (isRentPaymentCustom) {
              <astral-textarea
                class="astral-grid-full"
                [control]="form.controls['rentPaymentTerms']"
                [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENT_PAYMENT_TERMS'"
              ></astral-textarea>
            }
          </astral-layout-group>
        </section>

        <section class="astral-section-surface astral-stack-m">
          <ng-container *ngTemplateOutlet="invoicingPanelContent"></ng-container>
        </section>

        <section class="astral-section-surface astral-stack-m">
          <astral-textarea [control]="form.controls['specialTerms']"></astral-textarea>
        </section>
      </form>
    </div>
  </ng-template>

  <ng-template #invoicingSection>
    <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.INVOICING_HEADER'">
      <ng-container *ngTemplateOutlet="invoicingPanelContent"></ng-container>
    </astral-accordion>
  </ng-template>

  <ng-template #invoicingPanelContent>
    <div class="astral-stack-l">
      <app-contract-invoicing
        [form]="form"
        [dataContext]="dataContext"
        [tenantOne]="tenantOne"
        [addressForm]="form.controls['invoiceAddress']"
        [contractSpecificInvoiceAddress]="form.controls['individualInvoiceAddress'].value"
        [category]="dataContext.category"
        [company]="dataContext.company"
      ></app-contract-invoicing>

      <div class="astral-stack-m">
        <h4>{{ 'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER' | translate }}</h4>
        <astral-toggle
          [control]="form.controls['individualInvoiceAddress']"
          [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INDIVIDUAL_INVOICE_ADDRESS'"
        ></astral-toggle>
        <h6>{{ individualAddressMessage | translate }}</h6>
        <app-postal-address
          [group]="form.controls['invoiceAddress']"
          [model]="invoiceAddress"
          [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
          [showName]="true"
          [mandatory]="true"
          [title]="''"
        ></app-postal-address>
      </div>
    </div>
  </ng-template>
</section>
